import { useCallback } from 'react';

import { MAX_SELECTED_SYMBOLS } from '@/config/constants';
import type { CatalogItem } from '@/entities/catalog-item';
import type { SymbolKey } from '@/entities/symbol';
import { useSelectionFunctions } from '@/features/symbol-selector';
import Button from '@/shared/ui/primitives/Button';
import { parseForwardCurveRowToSymbol } from '../../../lib/parseForwardCurveRowToSymbol';

import type { Table } from '@tanstack/react-table';

const SelectAllButton = ({
  table,
  isForwardCurves
}: {
  table: Table<CatalogItem>;
  isForwardCurves: boolean;
}) => {
  const getFwdCurveSymbols = useCallback(() => {
    return table.getFilteredRowModel().rows.flatMap(row => parseForwardCurveRowToSymbol(row));
  }, [table]);
  const getSpotSymbols = useCallback(() => {
    return table.getFilteredRowModel().rows.flatMap(row => {
      return row.getValue<SymbolKey>('Symbol');
    });
  }, [table]);
  const { addSymbolsToSelection, addForwardCurvesToSelection } = useSelectionFunctions();
  const disabled = table.getRowModel().rows.length > MAX_SELECTED_SYMBOLS;
  return (
    <Button
      disabled={disabled}
      sx={{
        color: 'gx.highlight',
        ml: 1,
        px: 0.5,
        fontSize: 14,
        '&.Mui-disabled': {
          color: 'gx.highlight'
        }
      }}
      variant='text'
      onClick={() => {
        if (isForwardCurves) {
          addForwardCurvesToSelection(getFwdCurveSymbols());
        } else {
          addSymbolsToSelection(getSpotSymbols());
        }
      }}
    >
      Select All
    </Button>
  );
};
export default SelectAllButton;
